module.exports = __webpack_public_path__ + "static/media/arandas.png";